import { createSlice } from '@reduxjs/toolkit'

interface DeviceManagerState {
    deviceManagerSettings: any
}

const initialState: DeviceManagerState = {
    deviceManagerSettings: {},
}

const deviceManagerSlice = createSlice({
    name: 'org',
    initialState,
    reducers: {
        updateDeviceManagerSettings(state, action) {
            state.deviceManagerSettings = action.payload
        },
    },
})

export const { updateDeviceManagerSettings } = deviceManagerSlice.actions

export default deviceManagerSlice.reducer
